import { render, staticRenderFns } from "./ApmsBasicImageLibraryCategory.vue?vue&type=template&id=63eaa6ac&scoped=true&"
import script from "./ApmsBasicImageLibraryCategory.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicImageLibraryCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63eaa6ac",
  null
  
)

export default component.exports